import React from 'react';
import { Link } from 'react-router-dom';
export function Page31RelatedLinks() {
  return <section className="py-12 bg-subtle-gray/30 border-t border-subtle-gray" data-id="element-2822">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2823">
        <p className="text-sm font-bold text-gray-warm uppercase tracking-wide mb-6" data-id="element-2824">
          Explore More Classes & Programs
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-2825">
          <Link to="/SignMeUp" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-2826">
            Main Sign Me Up Page
          </Link>
          <Link to="/Programs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-2827">
            Programs Overview
          </Link>
          <Link to="/karate-kids-classes.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-2828">
            Kids Classes
          </Link>
          <Link to="/karate-adult-classes" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-2829">
            Adult Classes
          </Link>
          <Link to="/FamilyKarateClasses.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-2830">
            Family Classes
          </Link>
          <Link to="/ContactUs.html" className="text-ink hover:text-storm-red font-medium transition-colors" data-id="element-2831">
            Contact
          </Link>
        </div>
      </div>
    </section>;
}